/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Start_FinalsInputs */



/**
* | output |
* | --- |
* | "Start Finals" |
*
* @param {Overview_Start_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_start_finals = /** @type {((inputs?: Overview_Start_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Start_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencer la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciar finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Iniciar Finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia Finali")
	return /** @type {LocalizedString} */ ("Start Finals")
});